// extracted by mini-css-extract-plugin
module.exports = {"container":"TextEditor_container__1LiAP","barContainer":"TextEditor_barContainer__3r7SL","progress":"TextEditor_progress__qcftX"};